import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography } from '@mui/material';

const HeadingBlock = ({ data, isSelected, onUpdate, previewMode, blockId, onSelectBlock }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editContent, setEditContent] = useState(data.content || '');
  const inputRef = useRef(null);
  
  const {
    content = 'Your Heading',
    level = 'h2',
    fontSize = 24,
    color = '#333333',
    backgroundColor = 'transparent',
    fontWeight = 'bold',
    fontStyle = 'normal',
    textDecoration = 'none',
    textAlign = 'left',
    lineHeight = 1.2,
    marginTop = 20,
    marginBottom = 15,
    padding = 10,
    fontFamily = 'Arial, sans-serif',
  } = data;

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [isEditing]);

  // Синхронизируем содержимое при изменении данных извне
  useEffect(() => {
    if (!isEditing) {
      setEditContent(content);
    }
  }, [content, isEditing]);

  const getResponsiveFontSize = () => {
    switch (previewMode) {
      case 'mobile':
        return Math.max(fontSize * 0.85, 18);
      case 'tablet':
        return Math.max(fontSize * 0.9, 20);
      default:
        return fontSize;
    }
  };

  const blockStyles = {
    fontSize: `${getResponsiveFontSize()}px`,
    color,
    backgroundColor,
    fontWeight,
    fontStyle,
    textDecoration,
    textAlign,
    fontFamily,
    marginTop: `${marginTop}px`,
    marginBottom: `${marginBottom}px`,
    padding: `${padding}px`,
    border: isSelected ? '1px dashed #007bff' : 'none',
    borderRadius: isSelected ? '4px' : 0,
    cursor: 'text',
    minHeight: '30px',
    wordBreak: 'break-word',
    lineHeight,
  };

  const handleDoubleClick = (e) => {
    e.stopPropagation();
    setEditContent(content);
    setIsEditing(true);
  };

  const handleBlur = () => {
    setIsEditing(false);
    if (onUpdate && editContent !== content) {
      onUpdate({ content: editContent });
      
      // Обновляем selectedBlock если этот блок выбран
      if (onSelectBlock && blockId) {
        onSelectBlock({
          id: blockId,
          type: 'heading',
          data: { ...data, content: editContent }
        });
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleBlur();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      setIsEditing(false);
      setEditContent(content);
    }
  };

  if (isEditing) {
    return (
      <Box sx={{ ...blockStyles, padding: 0 }}>
        <input
          ref={inputRef}
          value={editContent}
          onChange={(e) => setEditContent(e.target.value)}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          style={{
            width: '100%',
            border: 'none',
            outline: 'none',
            fontSize: `${getResponsiveFontSize()}px`,
            color,
            fontWeight,
            fontStyle,
            textDecoration,
            textAlign,
            fontFamily,
            padding: `${padding}px`,
            backgroundColor: 'transparent',
            lineHeight,
          }}
          placeholder="Enter your heading..."
        />
      </Box>
    );
  }

  return (
    <Typography
      component={level}
      sx={blockStyles}
      onDoubleClick={handleDoubleClick}
    >
      {content || 'Double-click to edit heading...'}
    </Typography>
  );
};

export default HeadingBlock; 